const regexConstants = {
  email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/i,
  emptyString: /.*\S.*/,
  alphanumeric: /^[a-z0-9]+$/i,
  url: /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i,
  pngJpgSvg: /\.(?:jpg|png|svg)/i,
  onlyNumber: /^[0-9]*$/,
}

export default regexConstants
